import countries from './countries';

const configs = {
  API: 'https://stagingapi.pokerplaza.com/api_v2',
  MATCHES_API: 'https://matchpokerapi.draft10.com/api',
  API_MEDIA_URL: 'https://stagingapi.pokerplaza.com/api',
  TOURNAMENTS_URL: 'https://mipl.pokerplaza.com/mp_leaderboard/action.php',
  POKER_CLIENT_URL: 'https://matchpokerlv3.draft10.com/',
  POKER_CLIENT_URL_DESKTOP: 'https://matchpokerlv3.draft10.com/',
  LEADERBOARD_URL: 'https://mp.draftplaza.com/mpawsmigration/lb_1/',
  skinId: 49935,
  hierarchyId: 500778,
  auth: {
    password: {
      // Must contain at least one number and one lowercase letter, and at least 8 or more characters
      regexp: /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{6,}$/,
    },
    email: {
      regexp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
};

export default configs;
export { countries };
